import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { Box, Button, Tooltip } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MuiAlert from "@mui/material/Alert";

const useStyles = makeStyles(() => ({
  start: {
    display: "flex",
    justifyContent: "flex-start",
  },
  end: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function Technology(props) {
  const { state, onState, handleNext, classes, lablist } = props;
  const [temporary, settemporary] = useState({});
  const [find, setfind] = useState(false);
  const [startWithHyphen, setStartWithHyphen] = useState(false);
  const [numberfind, setnumberfind] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [templateapplication, setTemplateApplication] = useState([]);
  const [applicationTouched, setApplicationTouched] = useState(false); // New state to track if the application field has been touched

  const classes1 = useStyles();

  const handleReload = () => {
    window.location.reload();
  };

  const preventInvalidKeyInput = (e) => {
    // Block +, -, e, E, . (for number input)
    if (['+', '-', 'e', 'E', '.'].includes(e.key)) {
      e.preventDefault();
    }
    
    // Prevent entering more digits if already at max
    if (e.target.value.length >= 2 && e.key !== 'Backspace' && e.key !== 'Delete') {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;

    if (id === "application") {
      setApplicationTouched(true); // Set the field as touched on change
    }

    if (id === "nooftrainee") {
      setnumberfind(false);
      if (value > 25 || value < 1) {
        setnumberfind(true);
      } else {
        onState((prevState) => ({
          ...prevState,
          [id]: value,
        }));
        settemporary((prevState) => ({
          ...prevState,
          [id]: value,
        }));
      }
    } else {
      onState((prevState) => ({
        ...prevState,
        [id]: value,
      }));
      settemporary((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  const handle_budgetKeyPress = (event) => {
    const restrictedCharacters = ['_', '-', '%'];
    if (restrictedCharacters.includes(event.key)) {
      event.preventDefault();
    }
  };

  const handleLabNameChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    setfind(false);
    setStartWithHyphen(false);

    if (value.startsWith('-')) {
      setStartWithHyphen(true);
    } else {
      const labExists = lablist.some((instance) => instance.name === value);
      setfind(labExists);
    }

    onState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === '_') {
      event.preventDefault();
    }
  };

  const handleDescriptionChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    onState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  useEffect(() => {
    setShowAlert(temporary.name && !/^[a-z0-9_\-]{1,15}$/.test(temporary.name));
  }, [temporary.name]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/templaterequest/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setTemplateApplication(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const isNextButtonDisabled = !(
    temporary.name &&
    temporary.application &&
    temporary.nooftrainee &&
    !find &&
    !showAlert &&
    !numberfind &&
    !startWithHyphen
  );

  return (
    <React.Fragment>
      <Box sx={{ pb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Create Lab and Choose Application
        </Typography>
      </Box>
      {showAlert && (
        <Box sx={{ pb: 2 }}>
          <Alert severity="warning">
            Please enter lowercase letters and only up to 15 characters.
          </Alert>
        </Box>
      )}

      <Grid container spacing={4}>
        <Grid item md={4} xs={12}>
          <InputLabel>
            Name<small style={{ paddingLeft: "10px" }}>required</small>
            <small style={{ color: "red" }}>*</small>
          </InputLabel>
          <TextField
            fullWidth
            helperText={
              startWithHyphen
                ? "Name cannot start with a hyphen"
                : find
                ? "Lab name already exists, Please enter a unique name"
                : "Please specify the name"
            }
            name="name"
            id="name"
            color={temporary.name && !find && !startWithHyphen ? "success" : ""}
            error={find || startWithHyphen}
            onChange={handleLabNameChange}
            onKeyPress={handleKeyPress}
            required
            autoComplete="name"
            InputProps={{
              style: {
                height: "40px",
              },
            }}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <InputLabel>
            Applications<small style={{ paddingLeft: "10px" }}>required</small>
            <small style={{ color: "red" }}>*</small>
          </InputLabel>
          <TextField
            fullWidth
            name="application"
            id="application"
            onChange={handleChange}
            required
            select
            SelectProps={{ native: true }}
            autoComplete="shipping address-line1"
            InputProps={{
              style: {
                height: "40px",
              },
            }}
            error={applicationTouched && !temporary.application} // Only show error if the field has been touched and is empty
            helperText={applicationTouched && !temporary.application ? "Please select an application" : ""}
          >
            <option key="" value=""></option>
            {templateapplication.map((templateapplication) => {
              return (
                <option key={templateapplication} value={templateapplication}>
                  {templateapplication}
                </option>
              );
            })}
          </TextField>
        </Grid>
        <Grid item md={4} xs={12}>
          <InputLabel>
            Number of Trainee
            <small style={{ paddingLeft: "10px" }}>required</small>
            <small style={{ color: "red" }}>*</small>
          </InputLabel>
          <TextField
            fullWidth
            helperText={
              numberfind
                ? "Please enter a value less than or equal to (25)"
                : "Please specify the number"
            }
            name="nooftrainee"
            id="nooftrainee"
            onChange={handleChange}
            onKeyPress={handle_budgetKeyPress}
            onKeyDown={preventInvalidKeyInput}
            required
            autoComplete="nooftrainee"
            type="number"
            inputProps={{ min: "1", max: "25", step: "1" }}
            error={numberfind}
            InputProps={{
              style: {
                height: "40px",
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel>
            Description<small style={{ paddingLeft: "10px" }}>(optional)</small>
          </InputLabel>
          <TextField
            fullWidth
            name="description"
            id="description"
            onChange={handleDescriptionChange}
            autoComplete="family-name"
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
        <div>
          <Tooltip title="Cancel and discard changes">
            <span>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleReload}
                className={classes}
                sx={{ borderRadius: '50px' }}
              >
                Cancel
              </Button>
            </span>
          </Tooltip>
        </div>

        <div>
          <Tooltip title={isNextButtonDisabled ? "Please fill in all required fields" : "Proceed to the next step"}>
            <span>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                className={classes}
                disabled={isNextButtonDisabled}
                sx={{ borderRadius: '50px' }}
              >
                Next
              </Button>
            </span>
          </Tooltip>
        </div>
      </Box>
    </React.Fragment>
  );
}